<template>
  <div>
    <spaysuccess :type="orderType"></spaysuccess>
  </div>
</template>
<script>
import spaysuccess from '@/components/order/paysuccess.vue'
export default {
  name: 'paySuccess',
  components: {
    'spaysuccess': spaysuccess
  },
  data () {
    return {
      orderType: ''
    }
  },
  created() {
    if (this.$route.query.out_trade_no) {
      let query = {
        outTradeNo: this.$route.query.out_trade_no
      }
      this.sapost('/dmc/order/queryOrderByPayId', query, r => {
        let result = r.data
        if (result.result_code === 'SUCCESS') {
          this.orderType = result.orderType + ''
          console.log('订单信息查询成功！')
        } else {
          this.$message.warning(result.result_msg)
          this.$router.back()
        }
      })
    } else if (this.$route.query.orderId) {
      // 取出待支付的订单标识
      let id = this.$route.query.orderId
      console.log(`订单标识：${id}`)
      // 根据订单标识查询订单信息
      this.sapost(`/dmc/order/${id}`, '', r => {
        console.log(r.data)
        let result = r.data
        if (result.result_code === 'SUCCESS') {
          this.orderType = result.orderType + ''
          console.log('订单信息查询成功！')
        } else {
          this.$message.warning(result.result_msg)
          this.$router.back()
        }
      })
    } else {
      if (this.$route.query.orderType) {
        this.orderType = this.$route.query.orderType
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/PaySuccess.vue